import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=10046050&scoped=true&"
import script from "./ProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=10046050&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10046050",
  null
  
)

export default component.exports